import React from "react";
import { useNavigate } from "react-router-dom";
import Servicescontent from "./Servicescontent";
import Aboutus from "./Aboutus";
import Price from "./Price";
import GalleryImages from "./GalleryImages";
import Infokontakt from "./Infokontakt";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Footer from "./Footer";

function Indexpage() {
  const navigate = useNavigate();
  
  const handleClick = () => {
    navigate("/angebotanforden");
  };

  return (
    <div className="index-wrapper" style={{ overflowX: "hidden" }}>
      {/* Hero Section: 
          Kept the 'app' class so your existing CSS image remains, 
          but added flex and overlay for professionalism. 
      */}
      <div className="app" style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: "0 8%",
        position: "relative"
      }}>
        {/* Dark overlay to make text pop while keeping the image visible */}
        <div style={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(90deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.2) 100%)",
          zIndex: 1
        }}></div>

        <div className="maintext" style={{ 
          position: "relative", 
          zIndex: 2,
          maxWidth: "800px" 
        }}>
          <h1
            style={{
              fontFamily: "var(--fontFamily)",
              fontWeight: "800",
              fontSize: "clamp(2.5rem, 6vw, 4.5rem)", // Responsive size
              color: "#ffffff",
              lineHeight: "1.1",
              margin: "0 0 20px 0",
              textShadow: "2px 4px 10px rgba(0,0,0,0.3)"
            }}
          >
            <span
              className="span-name"
              style={{ color: "#01B8B0" }}
            >
              REIN
            </span>{" "}
            Glas und Gebäudereinigung
          </h1>

          <p style={{ 
              fontFamily: "var(--fontFamily)",
              fontSize: "22px",
              color: "rgba(255,255,255,0.9)",
              fontWeight: "400",
              marginBottom: "40px",
              letterSpacing: "0.5px"
          }}>
            Wir reinigen, Sie genießen. Perfektion bis ins Detail.
          </p>

          <Stack direction="row">
            <Button
              variant="contained"
              onClick={handleClick}
              className="buttokontanktApp"
              sx={{
                // MUI sx is better for responsive widths than inline style
                width: {
                  xs: "100%",
                  sm: "auto"
                },
                minWidth: "280px",
                height: "70px",
                backgroundColor: "#01B8B0",
                fontSize: "20px",
                fontWeight: "700",
                color: "#ffffff", // Standard high-contrast enterprise text
                textTransform: "none", // Avoids all-caps for a modern look
                borderRadius: "4px",
                boxShadow: "0 10px 20px -5px rgba(1, 184, 176, 0.4)",
                "&:hover": {
                  backgroundColor: "#019a93",
                  transform: "translateY(-2px)",
                  transition: "all 0.3s ease"
                }
              }}
            >
              Jetzt Angebot anfordern
            </Button>
          </Stack>
        </div>
      </div>

      {/* Structured Layout for Enterprise Flow */}
      <section style={{ padding: "80px 0" }}>
        <Servicescontent />
      </section>

      <section style={{ padding: "80px 0", backgroundColor: "#fcfcfc" }}>
        <Aboutus />
      </section>

      <section style={{ padding: "80px 0" }}>
        <Price />
      </section>

      <section style={{ padding: "60px 0" }}>
        <GalleryImages />
      </section>

      <div style={{ borderTop: "1px solid #eee" }}>
        <Infokontakt />
      </div>

      <Footer />
    </div>
  );
}

export default Indexpage;